module.exports = __webpack_public_path__ + "img/AS3485016.10eb0dc4.jpg";